module.exports = __webpack_public_path__ + "static/media/p20.c4dc3ceb.jpeg";